export class FetchError extends Error {
  constructor(
    message: string,
    readonly response: Response
  ) {
    super(message);
  }
}

export const unwrap = async <T>(res: Response) => {
  if (!res.ok) {
    throw new FetchError(
      `Request failed with status code: ${res.status} ${res.statusText}`,
      res
    );
  }

  return (await res.json()) as T;
};
